export const damageTypes = ['NENHUM', 'DANO']
